import { isArray, isObject, mapValues, mapKeys, camelCase } from 'lodash';

import type { SnakeToCamelCase } from './types';

export function convertObjectPropsToCamelCase<T>(obj: T): SnakeToCamelCase<T> {
  if (isArray(obj)) {
    // If the object is an array, recursively apply to each element
    return obj.map(convertObjectPropsToCamelCase) as SnakeToCamelCase<T>;
  }

  if (isObject(obj)) {
    // If the object is an object, recursively convert each key-value pair
    return mapValues(
      mapKeys(obj, (value, key) => camelCase(key)),
      convertObjectPropsToCamelCase
    ) as SnakeToCamelCase<T>;
  }

  // Return the value directly if it is neither an array nor an object
  return obj as SnakeToCamelCase<T>;
}
